import { sentryClientKey } from 'common/config/dev-config';
import type { CrashReporterData, CrashReporterTags } from 'common/models/crash-reporter.interface';

import { isDesktopApp, isLocalhost } from './client-utils';

const getEnvironment = () => {
  if (isLocalhost) return 'local';
  return process.env.POP_ENV;
};

export async function initCrashReporter() {
  if (isLocalhost) return;
  const { init } = await getSentry();
  init({
    dsn: sentryClientKey,
    environment: getEnvironment(),
    release: `web-${__CLIENT_VERSION__}`,
    enabled: !isLocalhost,
    debug: getEnvironment() === 'dev' || getEnvironment() === 'local',
  });
}

export async function setCrashReporterUserId(userId: string | null) {
  const { setUser } = await getSentry();
  setUser(userId ? { id: userId } : null);
}

const getSentry = () => (isDesktopApp ? import('@sentry/electron/renderer') : import('@sentry/browser'));

export const reportErrorToSentry = async ({
  error,
  tags,
  data,
}: {
  error: unknown;
  tags?: CrashReporterTags;
  data?: CrashReporterData;
}) => {
  (await getSentry()).withScope((scope) => {
    if (tags) scope.setTags(tags);
    if (data) scope.setExtras(data);
    scope.captureException(error);
  });
};
